import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'fr',
  lng: localStorage.getItem('language'),
  resources: {
    fr: {
      translations: require('./locales/fr/translations.json')
    },
    en: {
      translations: require('./locales/en/translations.json')
    },
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['fr', 'en'];

export default i18n;
